import { reaction, runInAction, action } from 'mobx';

import data from './data';
import { TABLET_BREAKPOINT } from './constants';

let page: HTMLElement | null = null;
let desktopSticky: HTMLElement | null = null;
let mobileSticky: HTMLElement | null = null;
let desktopStickyReferencePoint: HTMLElement | null = null;
let mobileStickyReferencePoint: HTMLElement | null = null;
let header: HTMLElement | null = null;
let content: HTMLElement | null = null;

function listenForModeChange() {
	const m = window.matchMedia( `(min-width: ${ TABLET_BREAKPOINT }px)` );

	const setupState = ( isDesktop: boolean ) => {
		if ( isDesktop ) {
			// Desktop mode
			data.stickyElement = desktopStickyReferencePoint;
			data.isDesktop = true;
		} else {
			// Mobile or tablet mode
			data.stickyElement = mobileStickyReferencePoint;
			data.isDesktop = false;
		}
	};

	const desktopHandler = action( ( e: MediaQueryListEvent ) => {
		setupState( e.matches );
	} );

	setupState( m.matches );

	m.addEventListener( 'change', desktopHandler );
}

export function initSticky() {
	content = document.querySelector( '#content' ) as HTMLElement;
	desktopStickyReferencePoint = document.querySelector(
		'#masthead .header-desktop > .header-desktop__iafxiuxgeu'
	) as HTMLElement;
	mobileStickyReferencePoint = document.querySelector(
		'#masthead .header-mobile > .header-mobile__pivzfnpsqc'
	) as HTMLElement;
	header = document.querySelector( '#masthead' ) as HTMLElement;
	listenForModeChange();
	const adminBar = document.querySelector( '#wpadminbar' );
	page = document.querySelector( '#page' ) as HTMLElement;
	desktopSticky = document.querySelector( '.header-desktop__bottom' );
	mobileSticky = document.querySelector(
		'.header-mobile__pivzfnpsqc > .header-mobile__wrapper'
	);

	const determineIfSticky = action( () => {
		if ( ! data.stickyElement ) {
			throw new Error( 'Missing sticky element' );
		}

		if ( adminBar ) {
			data.hasAdminBar = true;
			data.adminBarHeight = adminBar.getBoundingClientRect().height;
		} else {
			data.hasAdminBar = false;
			data.adminBarHeight = 0;
		}

		const screenTop = ( () => {
			if ( data.hasAdminBar ) {
				const adminBarHeight = data.adminBarHeight;
				return adminBarHeight;
			} else {
				return 0;
			}
		} )() as number;

		const stickyElement = data.stickyElement;

		const stickyElementTop = stickyElement.getBoundingClientRect().y;

		if ( stickyElementTop <= screenTop ) {
			data.isSticky = true;
		} else {
			data.isSticky = false;
		}
	} );

	const determineHeights = action( () => {
		if ( ! header || ! desktopSticky || ! mobileSticky ) {
			return;
		}

		data.heights.header = header.getBoundingClientRect().height;
		data.heights.mobileSticky = mobileSticky.getBoundingClientRect().height;
		data.heights.desktopSticky =
			desktopSticky.getBoundingClientRect().height;
	} );

	determineIfSticky();
	determineHeights();

	const animationCb = () => {
		determineIfSticky();
		determineHeights();
		window.requestAnimationFrame( animationCb );
	};

	window.requestAnimationFrame( animationCb );

	reaction(
		() => ( {
			isSticky: data.isSticky,
			hasAdminBar: data.hasAdminBar,
			isDesktop: data.isDesktop,
			adminBarHeight: data.adminBarHeight,
		} ),
		setupStickyHtml,
		{ fireImmediately: true }
	);

	reaction(
		() => ( {
			mobileHeight: data.heights.mobileSticky || null,
			desktopHeight: data.heights.desktopSticky || null,
			isDesktop: data.isDesktop,
		} ),
		setupHeightsHtml,
		{ fireImmediately: true }
	);
}

function setupHeightsHtml( { mobileHeight, desktopHeight, isDesktop } ) {
	if (
		! content ||
		! mobileStickyReferencePoint ||
		! desktopStickyReferencePoint
	) {
		throw new Error();
	}

	if ( mobileHeight && ! isDesktop ) {
		mobileStickyReferencePoint.style.minHeight = `${ mobileHeight }px`;
	}

	if ( desktopHeight && isDesktop ) {
		desktopStickyReferencePoint.style.minHeight = `${ desktopHeight }px`;
	}
}

function setupStickyHtml( {
	isSticky,
	hasAdminBar,
	isDesktop,
	adminBarHeight,
} ) {
	if ( ! page || ! mobileSticky || ! desktopSticky ) {
		throw new Error();
	}

	const element = isDesktop ? desktopSticky : mobileSticky;

	if ( ! isSticky && ! element.style.getPropertyValue( 'position' ) ) {
		// Nothing to do.
		return;
	}

	const edgeCoord = adminBarHeight;

	if ( isSticky && edgeCoord >= 0 ) {
		element.style.position = 'fixed';
		element.style.left = '0';
		element.style.right = '0';
		element.style.top = `${ edgeCoord }px`;
	} else {
		element.style.removeProperty( 'position' );
		element.style.removeProperty( 'left' );
		element.style.removeProperty( 'right' );
		element.style.removeProperty( 'top' );
	}
}
